import { gql } from "@apollo/client";

// Branches, customers, site groups, sites, employees and suppliers a user's
// data access can be limited to (Settings → Users & Teams → Data Access) —
// each list already narrowed to what the person asking can see themselves.
export const DataScopeOptionsQuery = gql`
query($input: DataScopeOptionsInput){
    dataScopeOptions(input: $input)
}
`;

// Can a detail page's record be shown to this user: "ok", "outsideScope" or
// "notFound" (see recordAccessGate).
export const RecordAccessQuery = gql`
query($kind: String!, $id: String!){
    recordAccess(kind: $kind, id: $id)
}
`;
